import moment from "moment";
import { languageService } from "../../../../../Language/language.service";

export const AddTestForm = {
  title: languageService("Add Test"),
  id: "AddTestSchema",
  stateTitle: {
    Add: languageService("Add Test"),
    Edit: languageService("Edit Test"),
  },
  sections: [
    {
      col: 6,
      id: "section1",
      fields: [
        {
          id: "test",
          type: "select",
          labelValue: languageService("Test"),
          selectOptions: [],
          required: true,
          showFieldsOnCertainValue: [
            {
              values: ["periodic92Days", "periodic184Days"],
              targetIds: ["item1", "item2", "item3", "item4", "item5", "item6", "item7", "bluecardItems"],
              inverse: false,
            },

            {
              //TODO: GET List based on autoCertify property in assetTest
              values: ["GandOReflectiveStripingReplacement", "GandOHornTestPerformed"],
              targetIds: ["certifiedBy", "certifiedDate"],
              inverse: true,
            },

            {
              //TODO: GET List based on autoCertify property in assetTest
              values: ["GandOReflectiveStripingReplacement", "GandOHornTestPerformed"],
              targetIds: ["comments"],
              inverse: false,
            },
          ],
        },

        {
          id: "location",
          type: "select",
          labelValue: languageService("Location"),
          selectOptions: [],
          required: true,
        },
        {
          id: "performedBy",
          type: "select",
          labelValue: languageService("Performed By"),
          selectOptions: [],
          required: true,
        },
        {
          id: "date",
          type: "date",
          labelValue: languageService("Performed Date"),
          required: true,
        },

        {
          id: "certifiedBy",
          type: "select",
          labelValue: languageService("Certified By"),
          selectOptions: [],
          required: true,
        },
        {
          id: "certifiedDate",
          type: "date",
          labelValue: languageService("Certified Date"),
          required: true,
        },
      ],
    },
    {
      col: 6,
      id: "section1",
      fields: [
        {
          id: "bluecardItems",
          labelValue: "Blue Card Items",
          type: "label",
        },
        {
          id: "item1",
          labelValue: "Brakes",
          type: "checkbox",
        },

        {
          id: "item2",
          labelValue: "Running Gear",
          type: "checkbox",
        },

        {
          id: "item3",
          labelValue: "Cab Equip",
          type: "checkbox",
        },

        {
          id: "item4",
          labelValue: "Mech Equip",
          type: "checkbox",
        },

        {
          id: "item5",
          labelValue: "Elect Equip",
          type: "checkbox",
        },

        {
          id: "item6",
          labelValue: "Steam Gen",
          type: "checkbox",
        },

        {
          id: "item7",
          labelValue: "Safety Appl",
          type: "checkbox",
        },

        {
          id: "comments",
          labelValue: "Comments",
          type: "input",
        },
      ],
    },

    {
      id: "footerArea",
      col: 12,
      fields: [
        {
          id: "submitData",
          type: "button",
          labelValue: languageService("Save"),
          action: "submit",
          callback: "onSubmit",
          position: "footer",
          col: 6,
        },

        {
          id: "closeDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/AssetView/BlueCard/InitaializeBlueCard/Schema/AddTestFormSchema.js